import { RequestState } from "vuex-fetch-factory";
import { ProjectModel } from "../models";

export interface StateInterface {
  vuexFetchersState: Map<string, Map<string, RequestState>>;
  projects: ProjectModel[];
  subscriptions: ProjectModel[];
}

const state: StateInterface = {
  vuexFetchersState: new Map(),
  projects: [],
  subscriptions: []
};

export default state;
